import { defineComponent as _defineComponent } from 'vue';
import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, renderSlot as _renderSlot, withKeys as _withKeys, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue";
import { ref, onMounted, watch } from 'vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'base-modal',
    props: {
        show: { type: Boolean, default: false }
    },
    emits: ["hide"],
    setup(__props, { emit: __emit }) {
        const visible = ref(false);
        const emit = __emit;
        onMounted(() => {
            visible.value = __props.show;
        });
        watch(() => __props.show, (state) => {
            if (state) {
                openModal();
            }
            else {
                closeModal();
            }
        });
        function openModal() {
            visible.value = true;
            document.body.style.overflow = 'hidden'; // Запрещаем прокрутку заднего фона
        }
        function closeModal() {
            visible.value = false;
            document.body.style.overflow = ''; // Восстанавливаем прокрутку заднего фона
        }
        function hide() {
            emit('hide');
        }
        return (_ctx, _cache) => {
            return (visible.value)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    class: _normalizeClass(_ctx.$style.overlay),
                    onKeydown: _withKeys(hide, ["esc"])
                }, [
                    _createElementVNode("div", {
                        class: _normalizeClass(_ctx.$style.modal)
                    }, [
                        _createElementVNode("header", {
                            class: _normalizeClass(_ctx.$style.header)
                        }, [
                            _createElementVNode("button", {
                                class: _normalizeClass(_ctx.$style.closeButton),
                                onClick: hide
                            }, "✕", 2)
                        ], 2),
                        _createElementVNode("section", {
                            class: _normalizeClass(_ctx.$style.main)
                        }, [
                            _renderSlot(_ctx.$slots, "content")
                        ], 2),
                        _createElementVNode("footer", {
                            class: _normalizeClass(_ctx.$style.footer)
                        }, [
                            _renderSlot(_ctx.$slots, "footer")
                        ], 2)
                    ], 2)
                ], 34))
                : _createCommentVNode("", true);
        };
    }
});
